'use strict';

/*
TODO needs a BIG REFACTORING to transform this validation in a component/module
there are too many code repeated doing the same thing.
*/

import Loader from '../../../_modules/loader/loader';

import { debounce, isFieldEmpty, isFieldSame, isDobEmpty, isValidEmail, displayErrors, displayInputError, isValidDob, goToNextSection, toggleProgressBar } from './_helper';
import { toaster } from './_material';

let $reports = $('.reports__page'),
    $startDateOrderReconciliation = $('#startDate--order-reconciliation'),
    $endDateOrderReconciliation = $('#endDate--order-reconciliation'),
    $startDateProductSales = $('#startDate--product-sale'),
    $endDateProductSales = $('#endDate--product-sale'),
    $startDateStockForecasting = $('#startDate--stock-forecasting'),
    $endDateStockForecasting = $('#endDate--stock-forecasting'),
    $startDateHcpClient = $('#startDate--hcp-client'),
    $endDateHcpClient = $('#endDate--hcp-client'),
    $startDateTableau = $('#startDate--tableau'),
    $endDateTableau = $('#endDate--tableau'),
    $startDateExpiringRegimens = $('#startDate--expiring-regimens'),
    $endDateExpiringRegimens = $('#endDate--expiring-regimens'),
    $instituteExpiringRegimens = $('#SearchInstituteExprReg'),
    $startDateRegimens = $('#startDate--regimens-report'),
    $endDateRegimens = $('#endDate--regimens-report'),
    $startDateNoOrders = $('#startDate--NoOrders'),
    $endDateNoOrders = $('#endDate--NoOrders'),
    $instituteNoOrders = $('#SearchInstituteNoOrd'),
    $instituteSalesRep = $('#SearchInstitute'),
    $requiredInputs = $('.form--register-hcp input'),
    $validationMessage = $('.validation--message'),
    _isInvalid = [];


$(() => {

    if (!$reports.length) {
        return false;
    }

    // Put Loader in a variable
    let loader = new Loader();


    $('#btn--order-reconciliation').on('click', function (e) {

        _isInvalid = [];


        if(isFieldEmpty($startDateOrderReconciliation)){
            e.preventDefault();

            $('.error-startDate--order-reconciliation')
                .slideDown({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            _isInvalid.push(0);

        }else{

            $('.error-startDate--order-reconciliation')
                .slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });

        }


        if(isFieldEmpty($endDateOrderReconciliation)){
            e.preventDefault();

            $('.error-endDate--order-reconciliation')
                .slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);

        }else{

            $('.error-endDate--order-reconciliation')
                .slideUp({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

        }

        if (_isInvalid.length > 0) {
            $(this).addClass('error');
            return false;
        } else {
            _isInvalid = [];
            $(this).removeClass('error');
        }
    });

    $('#btn--product-sales').on('click', function (e) {

        _isInvalid = [];


        if(isFieldEmpty($startDateProductSales)){
            e.preventDefault();

            $('.error-startDate--product-sale')
                .slideDown({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            _isInvalid.push(0);

        }else{

            $('.error-startDate--product-sale')
                .slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });
        }

        if(isFieldEmpty($endDateProductSales)){
            e.preventDefault();

            $('.error-endDate--product-sale')
                .slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);

        }else{

            $('.error-endDate--product-sale')
                .slideUp({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });
        }

        if (_isInvalid.length > 0) {
            $(this).addClass('error');
            return false;
        } else {
            _isInvalid = [];
            $(this).removeClass('error');
        }
    });

        $('#btn--stock-forecasting').on('click', function (e) {

        _isInvalid = [];


        if(isFieldEmpty($startDateStockForecasting)){
            e.preventDefault();

            $('.error-startDate--stock-forecasting')
                .slideDown({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            _isInvalid.push(0);

        }else{

            $('.error-startDate--stock-forecasting')
                .slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });
        }

        if(isFieldEmpty($endDateStockForecasting)){
            e.preventDefault();

            $('.error-endDate--stock-forecasting')
                .slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);

        }else{

            $('.error-endDate--stock-forecasting')
                .slideUp({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });
        }

        if (_isInvalid.length > 0) {
            $(this).addClass('error');
            return false;
        } else {
            _isInvalid = [];
            $(this).removeClass('error');
        }
    });

    $('#btn--tableau').on('click', function (e) {

        _isInvalid = [];


        if(isFieldEmpty($startDateTableau)){
            e.preventDefault();

            $('.error-startDate--tableau')
                .slideDown({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            _isInvalid.push(0);

        }else{

            $('.error-startDate--tableau')
                .slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });
        }

        if(isFieldEmpty($endDateTableau)){
            e.preventDefault();

            $('.error-endDate--tableau')
                .slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);

        }else{

            $('.error-endDate--tableau')
                .slideUp({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });
        }

        if (_isInvalid.length > 0) {
            $(this).addClass('error');
            return false;
        } else {
            _isInvalid = [];
            $(this).removeClass('error');
        }
    });

    // validation sales reps institution report
    $('#btn-sales-rep__report').on('click', function (e) {
        _isInvalid = [];

        let dataInstituteId = $instituteSalesRep.data('institution-id');

        if(isFieldEmpty($instituteSalesRep) || dataInstituteId == undefined || dataInstituteId === 0) {
            e.preventDefault();

            $('.error-institute--sales-rep')
                .slideDown({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });

            _isInvalid.push(0);
        }else{
            $('.error-institute--sales-rep')
                .slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });
        }

        if (_isInvalid.length > 0) {
            $(this).addClass('error');
            return false;
        } else {
            _isInvalid = [];
            $(this).removeClass('error');
        }

    });

    $('#btn--hcp-client').on('click', function (e) {

        _isInvalid = [];


        if(isFieldEmpty($startDateHcpClient)){
            e.preventDefault();

            $('.error-startDate--hcp-client')
                .slideDown({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            _isInvalid.push(0);

        }else{

            $('.error-startDate--hcp-client')
                .slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });
        }

        if(isFieldEmpty($endDateHcpClient)){
            e.preventDefault();

            $('.error-endDate--hcp-client')
                .slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);

        }else{

            $('.error-endDate--hcp-client')
                .slideUp({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });
        }

        if (_isInvalid.length > 0) {
            $(this).addClass('error');
            return false;
        } else {
            _isInvalid = [];
            $(this).removeClass('error');
        }
    });

    $('#btn--expiring-regimens').on('click', function (e) {

        _isInvalid = [];

        if($instituteExpiringRegimens.length){
          let dataInstituteIdExpReg = $instituteExpiringRegimens.data('institution-id');

          if(isFieldEmpty($instituteExpiringRegimens) || dataInstituteIdExpReg == undefined || dataInstituteIdExpReg === 0) {
              e.preventDefault();

              $('.error-institute--expiring-regimens')
                  .slideDown({
                      duration: 500,
                      easing: 'easeInOutExpo',
                      queue: false
                  });

              _isInvalid.push(0);
          }else{
              $('.error-institute--expiring-regimens')
                  .slideUp({
                      duration: 500,
                      easing: 'easeInOutExpo',
                      queue: false
                  });
          }
        }

        if(isFieldEmpty($startDateExpiringRegimens)){
            e.preventDefault();

            $('.error-startDate--expiring-regimens')
                .slideDown({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            _isInvalid.push(0);

        }else{

            $('.error-startDate--expiring-regimens')
                .slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });
        }

        if(isFieldEmpty($endDateExpiringRegimens)){
            e.preventDefault();

            $('.error-endDate--expiring-regimens')
                .slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);

        }else{

            $('.error-endDate--expiring-regimens')
                .slideUp({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });
        }

        if (_isInvalid.length > 0) {
            $(this).addClass('error');
            return false;
        } else {
            _isInvalid = [];
            $(this).removeClass('error');
        }
    });

    $('#btn--regimens-report').on('click', function (e) {

        _isInvalid = [];

        if(isFieldEmpty($startDateRegimens)){
            e.preventDefault();

            $('.error-startDate--regimens-report')
                .slideDown({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            _isInvalid.push(0);

        }else{

            $('.error-startDate--regimens-report')
                .slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });
        }

        if(isFieldEmpty($endDateRegimens)){
            e.preventDefault();

            $('.error-endDate--regimens-report')
                .slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);

        }else{

            $('.error-endDate--regimens-report')
                .slideUp({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });
        }

        if (_isInvalid.length > 0) {
            $(this).addClass('error');
            return false;
        } else {
            _isInvalid = [];
            $(this).removeClass('error');
        }
    });

    $('#btn--no-orders').on('click', function (e) {

        _isInvalid = [];
        if($instituteNoOrders.length){
          let dataInstituteIdNoOrd = $instituteNoOrders.data('institution-id');

          if(isFieldEmpty($instituteNoOrders) || dataInstituteIdNoOrd == undefined || dataInstituteIdNoOrd === 0) {
              e.preventDefault();

              $('.error-institute--no-orders')
                  .slideDown({
                      duration: 500,
                      easing: 'easeInOutExpo',
                      queue: false
                  });

              _isInvalid.push(0);
          }else{
              $('.error-institute--no-orders')
                  .slideUp({
                      duration: 500,
                      easing: 'easeInOutExpo',
                      queue: false
                  });
          }
        }

        if(isFieldEmpty($startDateNoOrders)){
            e.preventDefault();

            $('.error-startDate--no-orders')
                .slideDown({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            _isInvalid.push(0);

        }else{

            $('.error-startDate--no-orders')
                .slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });
        }

        if(isFieldEmpty($endDateNoOrders)){
            e.preventDefault();

            $('.error-endDate--no-orders')
                .slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);

        }else{

            $('.error-endDate--no-orders')
                .slideUp({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });
        }

        if (_isInvalid.length > 0) {
            $(this).addClass('error');
            return false;
        } else {
            _isInvalid = [];
            $(this).removeClass('error');
        }
    });
});
